import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import Config from "../Config";
import { Alert, Box, Button, Card, CardContent, Snackbar } from "@mui/material"; // #POW-4
import { useTranslation } from "react-i18next"; // #POW-29

const LoginPage = () => {
  const navigate = useNavigate();
  const { isReady, setStorageData } = useContext(AuthContext)
  const [ open, setOpen ] = useState(false)
  const { t } = useTranslation();  // #POW-29


  /**
   * Opens a pop-up window to handle Microsoft SSO
   */
  const handleLogin = () => {
    const authWindow = window.open(`${Config.serverUrl}/login`, "_blank", "width=500,height=600");

    const authCheckInterval = setInterval(() => {
      if (authWindow && authWindow.closed) {
        clearInterval(authCheckInterval);
        const token = localStorage.getItem("access_token"); // check the access token
        if (token) {
          navigate("/dashboard");
        }
      }
    }, 1000);
  };

  useEffect(() => {
    if (isReady) {
      // are we already logged-in ?
      navigate("/dashboard");
    }

    /**
     * Listeners for a postMessage coming from Python FastApi once succefully logged in,
     * please see /get-auth-token?code=...
     * @param event 
     */
    const handleAuthMessage = (event: MessageEvent) => {
      if (event.origin === Config.serverUrl && event.data.token) {
        setStorageData(event.data.token, event.data.userData); // SSO data + Worten entitlements
        navigate("/dashboard");
      }
      console.log(event.origin);
      if (event.origin === Config.serverUrl && event.data.error) {
        setOpen(true)
        setTimeout(() =>{setOpen(false)}, 2000)
      }
    };
    window.addEventListener("message", handleAuthMessage);

    return () => {
      window.removeEventListener("message", handleAuthMessage);
    };

  }, [navigate, isReady]);

  return (
    <>
    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', height: '100vh'}}> {/* #POW-4 */}
      <Card variant="outlined" sx={{ width: { xs: '80%', sm: 600 }, backgroundColor: '#EEEEEE', p:10 }}>
        <CardContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
            <img src="logo-worten.svg" alt="Worten logo" style={{ width: '80%', minWidth: '150px', height: 'auto', backgroundColor: '#E51B14', padding: '10px'}} />
            <img src="logo-picea.svg" alt="Picea logo" style={{ width: '80%', minWidth: '150px', height: 'auto'}} />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
              <Button variant="contained" size="small"
                sx={{
                  minWidth: 215,
                  padding: 0
                }}
                onClick={handleLogin}
              >
                <img src="ms-symbollockup_signin_light.svg" alt="MS signin"
                  style={{
                    width: '100%',
                    height: 'auto'
                  }}
                />
              </Button>
          </Box>
            
        </CardContent>
      </Card>
     </Box>

    <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert
        severity="error"
        variant="filled"
        sx={{ width: '100%' }}
      >
        {t('login.unauthorized')}
      </Alert>
    </Snackbar>
    </>
  );
};

export default LoginPage;